import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import { cloneDeep } from 'lodash';

import { Breadcrumb } from './breadcrumbs';
import { Enums } from '../../configs/Enums';
import { MAIN_PATHS } from '../../pages/main/main';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbsService {
  private _defaultBreadcrumbs = [{ text: Enums.projectName, url: null }];
  private _breadcrumbs: BehaviorSubject<Breadcrumb[]>;

  constructor(private router: Router) {
    this._breadcrumbs = new BehaviorSubject(this._defaultBreadcrumbs);
  }

  get breadcrumbsState() {
    return this._breadcrumbs.asObservable();
  }

  public updateBreadcrumbs(breadcrumbs: Breadcrumb[]) {
    let defaultBreadcrumbsClone = cloneDeep(this._defaultBreadcrumbs);
    let newBreadcrumbs = defaultBreadcrumbsClone.concat(breadcrumbs);

    if (this.router.url.indexOf('auth') === -1) {
      newBreadcrumbs[0].url = MAIN_PATHS.main;
    }

    this._breadcrumbs.next(newBreadcrumbs);
  }
}
